import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgBevestigen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#60D15D"
      d="M23.36 11H14V8l-6 6 6 6v-3h9.36a4.5 4.5 0 1 1 0 9H18v6h5.36a10.5 10.5 0 1 0 0-21"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m15.146 8.146.707.708L10.708 14l1.646 1.646-.707.708L9.293 14zM27.188 20.172A4 4 0 0 0 24.36 19v-1a5 5 0 1 1 0 10H16v-1h8.36a4 4 0 0 0 2.828-6.828"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgBevestigen);

export default ForwardRef;
